<div>
  <div [ngClass]="{ disabled: !session }">
    <!-- STEP_1_CONSENT START-->
    <form [formGroup]="consentForm" (ngSubmit)="next(0)">
      <div class="ic1-my-16" [ngClass]="{ stepComplete: isStepComplete(0) }">
        <ng-ui-kit-accordion
          [title]="MigrationSteps[0].title | translate"
          [open]="MigrationSteps[0].open"
          [icon]="isStepComplete(0) ? 'check' : ''"
          [step]="isStepComplete(0) ? 0 : MigrationSteps[0].step"
          [disabled]="MigrationSteps[0].disabled">
          <ng-container content>
            <ng-ui-kit-toast
              class="ic1-col-12"
              status="warning"
              [text]="
                'MIGRATION_PAGE.STEP_1_CONSENT.CERTIFICATE_EXPIRATION'
                  | translate
              ">
            </ng-ui-kit-toast>
            <div class="ic1-row">
              <div
                class="desc ic1-col-12"
                [innerHTML]="
                  'MIGRATION_PAGE.STEP_1_CONSENT.DESC_PERSONAL_INFORMATION'
                    | translate: personalData
                "></div>
              <div class="checkbox-container ic1-col-12 ic1-mt-16">
                <ng-ui-kit-checkbox
                  icId="c15"
                  [label]="''"
                  [error]="consentAttempted && !userAcceptedGeneralConditions.value"
                  dimension="large"
                  (change)="onConsentCheckboxChange($event)"
                  formControlName="userAcceptedGeneralConditions">
                </ng-ui-kit-checkbox>
                <span
                  [innerHTML]="
                    'MIGRATION_PAGE.STEP_1_CONSENT.MIGRATION_CONDITION'
                      | translate
                  "></span>
              </div>

              <div class="w-100"></div>
              <div class="ic1-col-12 ic1-col-lg-6 input">
                <ng-ui-kit-input
                  formControlName="pin"
                  name="pin"
                  autocomplete="pin"
                  [placeholder]="
                    'RENEW_PAGE.CONTRACT_SIGN_STEP.PIN_PLACEHOLDER' | translate
                  "
                  type="password"
                  icName="pin"
                  icId="pin"
                  [OnlyNumbers]="8"
                  [label]="'HOMEPAGE.PIN.TITLE' | translate"
                  [status]="
                    consentAttempted && pin.invalid
                      ? 'error'
                      : 'informative'
                  ">
                </ng-ui-kit-input>
                <app-field-validator
                  *ngIf="consentAttempted"
                  [field]="pin"
                  [formErrors]="contractSignFormErrors"></app-field-validator>
              </div>
              <div class="w-100"></div>
              <div class="ic1-col-12 buttons-container">
                <ng-ui-kit-button
                  *ngIf="modalMessageType === 'info'"
                  color="secondary"
                  [label]="'COMMON.BUTTON.CANCEL' | translate"
                  type="button"
                  size="sm"
                  (onClick)="closeMigrationModal()">
                </ng-ui-kit-button>
                <ng-ui-kit-button
                  color="primary"
                  [disabled]="loading"
                  [label]="'COMMON.BUTTON.CONFIRM' | translate"
                  type="button"
                  size="sm"
                  (onClick)="next(0)">
                </ng-ui-kit-button>
              </div>
            </div>

            <!-- <pre>{{ consentForm.value | json }}</pre> -->
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
    </form>
    <!-- FINE STEP_1_CONSENT -->

    <!-- STEP_2_OTP START -->
    <form [formGroup]="otpForm" (ngSubmit)="next(1)">
      <div class="ic1-my-16" [ngClass]="{ stepComplete: isStepComplete(1) }">
        <ng-ui-kit-accordion
          [title]="MigrationSteps[1].title | translate"
          [open]="MigrationSteps[1].open"
          [icon]="isStepComplete(1) ? 'check' : ''"
          [step]="isStepComplete(1) ? 0 : MigrationSteps[1].step"
          [disabled]="MigrationSteps[1].disabled">
          <ng-container content
            ><div class="ic1-col-12 desc ic1-mb-12" translate>
              COMMON.ACCORDION_OTP.DESC
            </div>
            <div class="ic1-col-12">
              <div class="ic1-form-group">
                <app-otp-input
                  formControlName="otp"
                  [error]="
                    otpAttempted && otp.invalid
                  "
                  [startTimer]="MigrationSteps[1].open"></app-otp-input>
              </div>
              <app-field-validator
                *ngIf="otpAttempted"
                [field]="otp"
                [formErrors]="otpFormErrors"></app-field-validator>
            </div>
            <div class="buttons-container ic1-mt-16">
              <ng-ui-kit-button
                *ngIf="modalMessageType === 'info'"
                color="secondary"
                [label]="'COMMON.BUTTON.CANCEL' | translate"
                type="button"
                size="sm"
                [disabled]="loading"
                (onClick)="closeMigrationModal()">
              </ng-ui-kit-button>
              <app-submit-button
                type="submit"
                [loading]="loading"
                [disabled]="loading"
                [label]="
                  loading ? 'loading...' : ('COMMON.BUTTON.CONFIRM' | translate)
                "
                (onClick)="next(1)"></app-submit-button>
            </div>
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
    </form>
    <!-- FINE STEP_2_OTP -->

    <!-- START STEP_3_NEW_PIN -->
    <form [formGroup]="newPinForm" (ngSubmit)="next(2)">
      <div class="ic1-my-16" [ngClass]="{ stepComplete: isStepComplete(2) }">
        <ng-ui-kit-accordion
          [title]="MigrationSteps[2].title | translate"
          [open]="MigrationSteps[2].open"
          [icon]="isStepComplete(2) ? 'check' : ''"
          [step]="isStepComplete(2) ? 0 : MigrationSteps[2].step"
          [disabled]="MigrationSteps[2].disabled">
          <ng-container content>
            <div class="ic1-row">
              <div class="ic1-col-12 desc ic1-mb-12">
                <div class="" translate>
                  MIGRATION_PAGE.STEP_3_NEW_PIN.DESCRIPTION
                </div>
                <div class="allert-pin">
                  <img
                    class="user-details-icon"
                    src="assets/images/info-icon.svg" />
                  <div translate="MIGRATION_PAGE.STEP_3_NEW_PIN.SAVE_PIN"></div>
                </div>
              </div>

              <!-- INPUT FIELDS -->
              <div class="ic1-col-12 ic1-col-lg-6">
                <ng-ui-kit-input
                  formControlName="newPin"
                  name="newPin"
                  autocomplete="newPin"
                  [placeholder]="
                    'MIGRATION_PAGE.STEP_3_NEW_PIN.PLACEHOLDER' | translate
                  "
                  type="password"
                  icName="newPin"
                  icId="newPin"
                  [OnlyNumbers]="8"
                  [label]="'MIGRATION_PAGE.STEP_3_NEW_PIN.INPUT' | translate"
                  [status]="
                    newPinAttempted && newPin.invalid
                      ? 'error'
                      : 'informative'
                  ">
                </ng-ui-kit-input>
                <app-field-validator
                  *ngIf="newPinAttempted"
                  [field]="newPin"
                  [formErrors]="contractSignFormErrors"></app-field-validator>
              </div>
              <div class="ic1-col-12 ic1-col-lg-6">
                <ng-ui-kit-input
                  formControlName="confirmPin"
                  name="confirmPin"
                  autocomplete="confirmPin"
                  [placeholder]="
                    'PIN_PAGE.ACCORDION.FIRST_STEP.CONFIRM_NEW_PIN_PLACEHOLDER'
                      | translate
                  "
                  type="password"
                  icName="confirmPin"
                  icId="confirmPin"
                  [OnlyNumbers]="8"
                  [label]="
                    'PIN_PAGE.ACCORDION.FIRST_STEP.CONFIRM_NEW_PIN_LABEL'
                      | translate
                  "
                  [status]="
                    newPinAttempted && confirmPin.invalid
                      ? 'error'
                      : 'informative'
                  ">
                </ng-ui-kit-input>
                <app-field-validator
                  *ngIf="newPinAttempted"
                  [field]="confirmPin"
                  [formErrors]="newPinFormErrors"></app-field-validator>

                <div
                  *ngIf="
                    newPinFormErrors?.['samePassword'] &&
                    hasNewPinsAtMinLength() &&
                    (newPin.dirty ||
                      newPin.touched ||
                      confirmPin.dirty ||
                      confirmPin.touched)
                  "
                  class="error"
                  translate>
                  COMMON.VALIDATORS.SAME_PASSWORD
                </div>
              </div>

              <div class="w-100"></div>
              <div class="ic1-col-12 buttons-container">
                <ng-ui-kit-button
                  *ngIf="modalMessageType === 'info'"
                  color="secondary"
                  [label]="'COMMON.BUTTON.CANCEL' | translate"
                  type="button"
                  size="sm"
                  (onClick)="closeMigrationModal()">
                </ng-ui-kit-button>
                <ng-ui-kit-button
                  color="primary"
                  [disabled]="loading"
                  [label]="'COMMON.BUTTON.CONFIRM' | translate"
                  type="button"
                  size="sm"
                  (onClick)="next(2)">
                </ng-ui-kit-button>
              </div>
            </div>
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
    </form>
    <!-- FINE STEP_3_NEW_PIN -->

    <!-- START STEP_4_PASSPHRASE -->
    <form [formGroup]="passphraseForm" (ngSubmit)="next(3)">
      <div class="ic1-my-16" [ngClass]="{ stepComplete: isStepComplete(3) }">
        <ng-ui-kit-accordion
          [title]="MigrationSteps[3].title | translate"
          [open]="MigrationSteps[3].open"
          [icon]="isStepComplete(3) ? 'check' : ''"
          [step]="isStepComplete(3) ? 0 : MigrationSteps[3].step"
          [disabled]="MigrationSteps[3].disabled">
          <ng-container content>
            <div class="">
              <div class="desc ic1-col-12" translate>
                MIGRATION_PAGE.STEP_4_PASSPHRASE.DESCRIPTION
              </div>

              <div class="w-100"></div>
              <div class="check-input-container">
                <div class="ic1-col-12 ic1-col-lg-6 input">
                  <ng-ui-kit-input
                    formControlName="passphrase"
                    name="passphrase"
                    autocomplete="passphrase"
                    [placeholder]="
                      'RENEW_PAGE.PASSPHRASE_STEP.PASSPHRASE_LABEL' | translate
                    "
                    type="password"
                    icName="passphrase"
                    icId="passphrase"
                    [label]="
                      'MIGRATION_PAGE.STEP_4_PASSPHRASE.INPUT' | translate
                    "
                    [status]="
                      passphraseAttempted && passphrase.invalid
                        ? 'error'
                        : 'informative'
                    ">
                  </ng-ui-kit-input>
                  <app-field-validator
                    *ngIf="passphraseAttempted"
                    [field]="passphrase"
                    [formErrors]="passphraseFormErrors"></app-field-validator>
                </div>
                <div
                  class="ic1-col-6 ic1-mt-16"
                  id="checkbox"
                  *ngIf="CF !== ''">
                  <ng-ui-kit-checkbox
                    icId="c17"
                    [label]="'RENEW_PAGE.PASSPHRASE_STEP.CF_LABEL' | translate"
                    dimension="large"
                    (change)="setCF($event)">
                  </ng-ui-kit-checkbox>
                </div>
              </div>

              <div class="ic1-col-12 buttons-container">
                <ng-ui-kit-button
                  *ngIf="modalMessageType === 'info'"
                  color="secondary"
                  [label]="'COMMON.BUTTON.CANCEL' | translate"
                  type="button"
                  size="sm"
                  (onClick)="closeMigrationModal()">
                </ng-ui-kit-button>
                <ng-ui-kit-button
                  color="primary"
                  [disabled]="loading"
                  [label]="'COMMON.BUTTON.CONFIRM' | translate"
                  type="button"
                  size="sm"
                  (onClick)="next(3)">
                </ng-ui-kit-button>
              </div>
            </div>
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
    </form>
    <!-- FINE STEP_4_PASSPHRASE -->
    <!-- STEP_5_OTP START -->
    <form [formGroup]="newOtpForm" (ngSubmit)="next(4)">
      <div class="ic1-my-16" [ngClass]="{ stepComplete: isStepComplete(4) }">
        <ng-ui-kit-accordion
          [title]="MigrationSteps[4].title | translate"
          [open]="MigrationSteps[4].open"
          [icon]="isStepComplete(4) ? 'check' : ''"
          [step]="isStepComplete(4) ? 0 : MigrationSteps[4].step"
          [disabled]="MigrationSteps[4].disabled">
          <ng-container content
            ><div class="ic1-col-12 desc ic1-mb-12" translate>
              COMMON.ACCORDION_OTP.DESC
            </div>
            <div class="ic1-col-12">
              <div class="ic1-form-group">
                <app-otp-input
                  formControlName="newOtp"
                  [error]="
                    newOtpAttempted && newOtp.invalid
                  "
                  [startTimer]="MigrationSteps[4].open"></app-otp-input>
              </div>
              <app-field-validator
                *ngIf="newOtpAttempted"
                [field]="newOtp"
                [formErrors]="newOtpFormErrors"></app-field-validator>
            </div>
            <div class="buttons-container ic1-mt-16">
              <ng-ui-kit-button
                *ngIf="modalMessageType === 'info'"
                color="secondary"
                [label]="'COMMON.BUTTON.CANCEL' | translate"
                type="button"
                size="sm"
                [disabled]="loading"
                (onClick)="closeMigrationModal()">
              </ng-ui-kit-button>
              <app-submit-button
                type="submit"
                [loading]="loading"
                [disabled]="loading"
                [label]="
                  loading ? 'loading...' : ('COMMON.BUTTON.CONFIRM' | translate)
                "
                (onClick)="next(4)"></app-submit-button>
            </div>
          </ng-container>
        </ng-ui-kit-accordion>
      </div>
    </form>
    <!-- FINE STEP_5_OTP -->
  </div>
  <app-common-modal
    modalId="migration-success-modal"
    [title]="'MIGRATION_PAGE.BANNER.MODAL_SUCCESS.TITLE' | translate"
    [(visible)]="migrationSuccessModalVisible"
    [config]="{ size: 'md', persistent: true, hideButtons: true }"
    (onClose)="onToggleMigrationSuccessModal(false)">
    <div class="modal-content">
      <div class="icon-info">
        <img
          class="user-details-icon icon-settings"
          src="assets/images/success-icon.svg" />
      </div>
      <h2>
        <div
          class="title content"
          [translate]="'MIGRATION_PAGE.BANNER.MODAL_SUCCESS.TITLE'"></div>
      </h2>
      <div
        class="description content"
        [translate]="'MIGRATION_PAGE.BANNER.MODAL_SUCCESS.DESCRIPTION'"></div>
      <div class="buttons-container ic1-mt-16">
        <ng-ui-kit-button
          class="mobile"
          color="primary"
          [label]="'MIGRATION_PAGE.BANNER.MODAL_SUCCESS.BUTTON' | translate"
          type="button"
          (onClick)="closeModalOnCompleteMigration()">
        </ng-ui-kit-button>
      </div>
    </div>
  </app-common-modal>
</div>
